import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { RayForm } from '../common';
import { ProductAction, RayCodeAction, AuthAction } from '../../actions';
import { Translate as t } from '../../config/Translate';
import CustomFieldValues from '../../components/customfield/CustomFieldValues';

// SEC-015: extradata $set 키 prefix 단일 출처 + BE _hasUnsafeSegment 미러링용 위험 세그먼트.
const EXTRADATA_PREFIX = 'extradata.';
const UNSAFE_KEY_SEGMENTS = ['__proto__', 'prototype', 'constructor'];

const ProductInfoExtra = ({ UpdateProductInfo, clist, productInfo, editable, favList, UpdateUserFav, updateUserSetting, user }) => {

	const [codeList, setCodeList] = useState([]);
	const [tables, setTables] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(true);
	const [edit, setEdit] = useState(false);
	const [showAll, setShowAll] = useState(false);
	const [showOnlyFav, setOnlyFav] = useState(false);
	const [favItems, setFavItems] = useState([]);

	useEffect(() => {
		setCodes();
	}, [clist]);

	useEffect(() => {
		setFavItems(favList || []);
	}, [favList]);

	useEffect(() => {
		if (loading) {
			makeList();
		}
	}, [codeList, favItems, showOnlyFav, search]);

	useEffect(() => {
		setShowAll(user.settings && user.settings.prdextrashopall);
		setOnlyFav(user.settings && user.settings.prdextrafavonly);
	}, [user.settings]);

	const setCodes = async () => {
		setCodeList(clist?.filter(x => x.type === 'PRODUCTEXTRAKEY'));
		//setCodeList(await RayCodeAction.GetAllByFilter({ type: "PRODUCTEXTRAKEY" }));
	}

	const groupBy = (items, key) => items.reduce(
		(result, item) => ({ ...result, [item[key]]: [...(result[item[key]] || []), item,], }), {},
	);

	const getFType = (m) => {
		if (m.datatype == "STRING") {
			return "input"
		} else if (m.datatype == "DATETIME") {
			return "datetime"
		} else if (m.datatype == "BOOLEAN") {
			return "checkbox"
		}
		return "input"
	}

	const makeList = () => {
		const tableList = [];
		const nSearch = search.toUpperCase();
		const objList = groupBy(codeList.filter(x => {
			return nSearch != "" ? (x.name.toUpperCase().indexOf(nSearch) > -1) : true
		}), "group");

		Object.keys(objList).map(t => {
			let cSort = 0;
			if (t == "H/W SN") cSort = 0;
			else if (t == "H/W FW") cSort = 1;
			else if (t == "S/W Version") cSort = 2;
			else if (t == "3D Viewer") cSort = 3;
			else if (t == "Workstation") cSort = 4;
			else if (t == "AditionalItems") cSort = 5;
			else if (t == "Appendix") cSort = 6;
			else if (t == "ETC") cSort = 7;
			else cSort = 8;
			const table = [];
			const item = {
				title: t,
				items: objList[t].filter(y => showOnlyFav ?
					favItems.includes(EXTRADATA_PREFIX + y.code) : true
				).map(m => {
					const ftype = getFType(m);
					return {
						type: ftype,
						name: EXTRADATA_PREFIX + m.code,
						label: m.name,
						val: productInfo.extradata && productInfo.extradata[m.code],
						inline: true,
						showpin: true,
						pinned: favItems.includes(EXTRADATA_PREFIX + m.code),
						isEditable: editable
					}
				}),
				csort: cSort
			};
			table.push(item)
			tableList.push(table);
		})
		setTables(tableList);
		setLoading(true);
	}

	const handleUpdateData = (e) => {
		// SEC-015 (회귀 검색 키워드: SEC-015 product mass assignment FE 가드):
		//   e.target.name(DOM 변조 가능)을 extradata.* 화이트리스트로 제한 + unsafe segment(__proto__ 등) 차단.
		//   BE sanitizeProductUpdate($set extradata.* prefix + _hasUnsafeSegment)와 동일 계약. /product/<sn> 경로.
		const key = e.target.name;
		const val = e.target.value;
		const isExtradataKey = typeof key === 'string' && key.startsWith(EXTRADATA_PREFIX);
		const hasUnsafeSegment = typeof key === 'string' && key.split('.').some(seg => seg === '' || UNSAFE_KEY_SEGMENTS.includes(seg));
		if (!isExtradataKey || hasUnsafeSegment) {
			console.warn('[ProductInfoExra.handleUpdateData] non-extradata key blocked', {
				component: 'ProductInfoExra',
				caller: user?.adminid,
				name: key,
				reason: 'SEC-015 FE 화이트리스트 — extradata.* 만 허용 + unsafe segment 차단 (DOM 변조 방어)',
			});
			return;
		}
		const obj = {};
		obj[key] = val;
		UpdateProductInfo(productInfo._id, { '$set': obj });
	}

	const fav = () => {
	}

	const removeArr = (id) => {
		const idx = favItems.indexOf(id);
		if (idx > -1) {
			favItems.splice(idx, 1);
		}
		return favItems;
	}

	const onpinupdate = (e) => {
		UpdateUserFav("productoptions", e.pinned ?
			{ favoriteProductOptions: removeArr(e.name) } :
			{ favoriteProductOptions: [...favItems, e.name] });
	}

	const showOptions = (type, val) => {
		// IMP-236: action creator 가 `settings.<type>` payload 책임을 가져감.
		// 호출 사이트는 type/val 의도만 전달. BE 계약 변경 시
		// AuthAction.updateUserSetting 한 곳만 수정.
		updateUserSetting(type, val);
	}

	const UpdateExtra = (code, value) => {
		UpdateProductInfo(productInfo._id, {
			customfieldvals: { ...productInfo.customfieldvals, [code]: value }
		});
	}

	return (
		<div className="section">
			<div className="row">
				<div className="col-4">
					<div className="card">
						<div className="card-body">
							{!productInfo.orisn && <button
								className={edit ? "btn btn-secondary btn-block" : "btn btn-primary btn-block"}
								onClick={e => setEdit(!edit)}>
								{edit ? t('common.status.locked') : t('common.status.unlocked')}
							</button>}
							<div className="form-group basic">
								<div className="input-wrapper">
									<label>{t('common.button.search')}</label>
									<input type="input"
										className={loading ? "form-control" : "form-control disabled"}
										onChange={e => setSearch(e.target.value)} value={search} />
								</div>
							</div>
						</div>
					</div>
					<div className="card mt-1">
						<ul className="listview simple-listview transparent flush">
							<li>
								<div><strong>{t('common.button.viewAllItems')}</strong></div>
								<div className="form-check form-switch" onClick={e => showOptions("prdextrashopall", !showAll)}>
									<input className="form-check-input" type="checkbox" checked={showAll} />
									<label className="form-check-label"></label>
								</div>
							</li>
							<li>
								<div><strong>{t('user.label.myFavorites')}</strong></div>
								<div className="form-check form-switch" onClick={e => showOptions("prdextrafavonly", !showOnlyFav)}>
									<input className="form-check-input" type="checkbox" checked={showOnlyFav} />
									<label className="form-check-label"></label>
								</div>
							</li>
						</ul>
					</div>
					<div className="card mt-1">
						<CustomFieldValues model={"PRODUCT"} update={UpdateExtra} data={productInfo.customfieldvals || {}} />
					</div>
				</div>
				<div className="col-8">
					{tables.sort((a, b) => a[0].csort - b[0].csort).map((table) => {
						return <RayForm
							data={productInfo}
							handleUpdateData={handleUpdateData}
							showAllFields={edit || search != "" || showAll || showOnlyFav}
							onpinupdate={onpinupdate}
							controls={table}
							showPin={true}
							isForm={edit} />
					})}
				</div>
			</div>
		</div>
	)
};

const mapState = (state) => {
	const prd = state.ProductReducer.product;
	const favList = state.FavoriteReducer.productoptions;
	const user = state.AuthReducer.user;
	const clist = state.RayCodeReducer.items;
	return { prd, favList, user, clist };
};

const mapDispatch = (dispatch) => ({
	UpdateProductInfo: (_id, data) => dispatch(ProductAction.UpdateProductInfo(_id, data)),
	UpdateUserFav: (type, data) => dispatch(AuthAction.UpdateUserFav(type, data)),
	// IMP-236: dotted payload 추상화. 호출 사이트는 type/value 의도만 전달.
	updateUserSetting: (name, value) => dispatch(AuthAction.updateUserSetting(name, value)),
});

export default connect(mapState, mapDispatch)(ProductInfoExtra);
